// @file Composable for Microsoft OneDrive

export const useMicrosoftOneDrive = (): {
  requestMicrosoftOneDriveAuthorization: typeof requestMicrosoftOneDriveAuthorization
} => {
  const requestMicrosoftOneDriveAuthorization = async ({
    onCloseBeforeAuth = () => {},
  }: {
    onCloseBeforeAuth?: () => void
  }): Promise<{ email: string; token: string }> => {
    return await new Promise((resolve, reject) => {
      const cleanup = (): void => {
        window.removeEventListener('microsoft_onedrive_auth', microsoftOauthTokenResponseHandler)
        clearInterval(interval)
      }

      const microsoftOauthTokenResponseHandler = (result: any): void => {
        cleanup()
        return resolve({ email: result.detail.email, token: result.detail.accessToken })
      }

      window.addEventListener('microsoft_onedrive_auth', microsoftOauthTokenResponseHandler)

      const oauthPath = `/auth/ms_graph?scope_alias=onedrive_picker&afterwards=dispatch_parent_drive`
      let oauthWindow: Window | null = null
      try {
        oauthWindow = window.open(oauthPath, 'microsoft_onedrive_oauth')
        if (oauthWindow != null) {
          oauthWindow.focus()
        } else {
          cleanup()
          return reject(new Error('Failed to open OAuth window'))
        }
      } catch (error) {
        cleanup()
        return reject(error)
      }

      const interval = setInterval(() => {
        if (oauthWindow?.closed) {
          cleanup()
          onCloseBeforeAuth()
        }
      }, 500)
    })
  }

  return {
    requestMicrosoftOneDriveAuthorization,
  }
}
